export enum CheckListItemType {
  AdminCheck = 'AdminCheck',
  HeavyCheck = 'HeavyCheck',
  Both = 'Both',
}

export interface Template {
  id: string
  name: string
  type: string
  address: string
  description: string
  createdDate: string
  lastModifiedDate: string
  isActive: boolean
  isDerived: boolean
  baseTemplateId: string
  cityId: string
  initialVersionName: string
  versionNumber: string
}
export interface TemplateVersion {
  id: string
  templateId: string
  name: string
  versionNumber: number
  initialVersionName: string
  isCurrent: boolean
  createdDate: string
  lastModifiedDate: string
  cityId: string
  totalRequiredDocuments: number
  totalChecklistItems: number
  totalSelectedItems: number
}
export interface TemplateListItem {
  id: string
  name: string
  type: string
  address: string
  description: string

  createdDate: string
  lastModifiedDate: string

  isActive: boolean
  isDerived: boolean

  baseTemplateId: string | null
  baseTemplateName: string | null

  cityId: string

  totalVersionsCount: number
  currentVersionNumber: number
  currentVersionName: string
  currentVersionId: string
  currentVersionCreatedDate: string

  totalRequiredDocumentsCount: number
  totalChecklistEntitiesCount: number
  totalChecklistItemsCount: number
  totalSelectedItemsCount: number
}
export interface TemplateListItems {
  items: TemplateListItem[]
}

export interface TemplateVersionChecklistItem {
  id: string
  name: string
  description: string
  isRequired: boolean
  order: number
  isSelected: boolean
  isMandatory: boolean
  capabilityCheckId: string | null
  capabilityName: string | null
  capabilityFileType: string | null
  capabilityCategory: string | null
  capabilityMechanism: string | null
  capabilityCheckOrigin: string | null
  checkListItemType: CheckListItemType
}

export interface TemplateVersionChecklistEntity {
  id: string
  name: string
  description: string
  order: number
  checkListItems: TemplateVersionChecklistItem[]
}

export interface TemplateVersionRequiredDocument {
  id: string
  name: string
  description: string
  isRequired: boolean
  order: number
  checkListEntities: TemplateVersionChecklistEntity[]
}

export interface TemplateVersionDetails {
  id: string
  templateId: string
  templateName: string
  description: string
  versionNumber: number
  versionName: string
  isCurrent: boolean
  isDeleted: boolean
  createdDate: string
  lastModifiedDate: string
  cityId: string
  totalRequiredDocuments: number
  totalChecklistEntities: number
  totalChecklistItems: number
  totalSelectedItems: number
  totalMandatoryItems: number
  requiredDocuments: TemplateVersionRequiredDocument[]
}
export interface CheckListEntity {
  name: string
  templateId: string
  id?: string
}

export interface CheckListItem {
  name: string
  isRequired: boolean
  checkListEntityId: string
  id?: string
}

export interface CheckListEntityDto {
  name: string
  templateId?: string
  id?: string
  key?: string
  checkListItems: CheckListItemDto[]
}

export interface CheckListItemDto {
  name: string
  isRequired: boolean
  checkListEntityId?: string
  id?: string
  key?: string
}

export interface saveTemplatePayload {
  id?: string
  name: string
  type: string
  address: string
  description: string
  cityId: string
  checkListEntities: CheckListEntityDto[]
  isDerived: boolean
  baseTemplateId?: string
}

export interface updateTemplatePayload {
  id: string
  name: string
  type: string
  address: string
  description: string
  cityId: string
  isDerived: boolean
  baseTemplateId?: string
  checkListEntities: CheckListEntityDto[]
  checkListItems: CheckListItemDto[]
}
export interface TemplateVersion {
  id: string
  versionNumber: number
  versionName: string

  isCurrent: boolean
  isDeleted: boolean

  createdDate: string
  lastModifiedDate: string

  totalRequiredDocuments: number
  totalChecklistItems: number
  totalSelectedItems: number
}
export interface TemplateVersionsResponse {
  templateId: string
  templateName: string
  templateType: string

  templateCreatedDate: string

  versions: TemplateVersion[]
  totalRequiredDocuments: number
  totalChecklistItems: number
  totalSelectedItems: number
  activeVersionsCount: number

  lastUpdatedDate: string
}

export interface TemplateVersionSummary {
  id: string
  initialVersionName: string
  versionNumber: number
  templateId: string
  templateName: string
}
export interface TemplateFormData {
  id: string
  templateId: string
  name: string
  type: string
  address: string
  description: string
  cityKey: string
  requiredDocuments: RequiredDocument[]
  initialVersionName: string
}

export interface RequiredDocument {
  id: string
  name: string
  order?: number
  description: string
  isRequired: boolean
  isDeleted?: boolean
  kind?: string | null
  entities: Entity[]
}

export interface DocumentKindOption {
  value: string
  label: string
}
export interface Entity {
  id: string
  name: string
  order?: number
  description: string
  isRequired: boolean
  isDeleted?: boolean
  selectedItems: SelectedItem[]
}

export interface SelectedItem {
  id: string
  // qc_api Capabilities check id (e.g. "an-01") — every checklist item,
  // AdminCheck or HeavyCheck, is selected from the Capabilities picker
  // now (see PredefinedItem below); there's no separate legacy path.
  capabilityCheckId: string
  capabilityName?: string
  capabilityFileType?: string
  capabilityCategory?: string
  capabilityMechanism?: string
  capabilityCheckOrigin?: string
  order?: number
  name?: string
  checkListItemType: CheckListItemType
  isDeleted?: boolean
  isRequired: boolean
}

export interface PredefinedItem {
  id: string
  name: string
  fileType?: string
  category?: string
  mechanism?: string
  checkOrigin?: string
}

type CreateVersionSelectedItem = Omit<
  SelectedItem,
  'id' | 'name' | 'isDeleted'
> & {}

type CreateVersionEntity = Omit<
  Entity,
  'id' | 'isDeleted' | 'selectedItems'
> & {
  selectedItems: CreateVersionSelectedItem[]
}

type CreateVersionRequiredDocument = Omit<
  RequiredDocument,
  'id' | 'isDeleted' | 'entities'
> & {
  entities: CreateVersionEntity[]
}

export interface CreateTemplateVersionPayload {
  name: string
  description: string
  templateId: string
  versionName: string
  cityKey: string
  requiredDocuments: CreateVersionRequiredDocument[]
}
